export default "__VITE_ASSET__H0mxbqg3__"